import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  if (!config.public.sentryDsn) {
    console.warn('Sentry DSN not set, skipping Sentry initialization')
    return
  }

  if (!config.public.sentryEnabled) {
    console.warn('Sentry not enabled, skipping Sentry initialization')
    return
  }

  Sentry.init({
    dsn: config.public.sentryDsn,
    environment: config.public.sentryEnvironment,
    release: config.public.sentryRelease,
    app: nuxtApp.vueApp,
    integrations: [],
  })

  return {
    provide: {
      sentryCaptureException: Sentry.captureException,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentrySetUser: Sentry.setUser,
    },
  }
})
